import api from '@/services/api'

/**
 * 获取二级分类列表
 * @param {number} wholesalerId - 批发商ID
 * @param {string} categoryName - 一级分类名称（可选）
 */
export function getSubCategories(wholesalerId, categoryName) {
  const params = { wholesalerId }
  if (categoryName) {
    params.categoryName = categoryName
  }
  return api.get('/sub-categories', { params })
}

/**
 * 创建二级分类
 * @param {number} wholesalerId - 批发商ID
 * @param {object} data - 分类数据
 */
export function createSubCategory(wholesalerId, data) {
  return api.post('/sub-categories', data, { params: { wholesalerId } })
}

/**
 * 更新二级分类
 * @param {number} wholesalerId - 批发商ID
 * @param {number} id - 分类ID
 * @param {object} data - 分类数据
 */
export function updateSubCategory(wholesalerId, id, data) {
  return api.put(`/sub-categories/${id}`, data, { params: { wholesalerId } })
}

/**
 * 删除二级分类
 * @param {number} wholesalerId - 批发商ID
 * @param {number} id - 分类ID
 */
export function deleteSubCategory(wholesalerId, id) {
  return api.delete(`/sub-categories/${id}`, { params: { wholesalerId } })
}

/**
 * 获取二级分类列表（用于商品编辑页，合并系统+自定义）
 * @param {string} categoryName - 一级分类名称
 */
export function getProductSubCategories(categoryName) {
  return api.get('/product/sub-categories', { params: { categoryName } })
}
